import { Buttons } from "../../../generic-sprites/Buttons"
import { Rectangle } from "../../../generic-sprites/Shape"
import { Audio } from "../../../utils/Audio"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { PersonalityAssets } from "../PersonalityAssets"
import { PersonalityStore } from "../PersonalityStore"
import { PersonalityType } from "../PersonalityType"


class PersonalityDropDownConfig {
    x?: number
    y?: number
    placeholder?: string
    fontPx?: number = 18
    blankNum?: 1 | 2 | 3 | 4 | 5
    personalityType?: PersonalityType
    isTitleMenu?: boolean = false
    group?: Phaser.Group
}

export class PersonalityDropDownMenu {

    private readonly dropGroup: Phaser.Group

    constructor(
        private game: Phaser.Game, optionArray: Array<string>,
        {x, y, fontPx = 18, placeholder, blankNum, personalityType, isTitleMenu, group}: PersonalityDropDownConfig = {}
    ) {
        // adjustment for placement
        y -= 8
        this.dropGroup = game.add.group()
        const paddingX = Scale.x(0.01)
        const paddingY = Scale.y(0.01)
        const scaledHeightFromPx = Math.floor(fontPx * Scale.scaleAmount())
        let width = 0
        let height = scaledHeightFromPx

        const closeDropDownOverlay = new Rectangle(game, 0, 0, Scale.x(1), Scale.y(1), {
            fillAlpha: 0.2,
            fillColor: 0x000000,
            group: this.dropGroup,
        })

        const list = PhaserText.list(game, {fontPx, x: x + paddingX, y, group: this.dropGroup})
        const selectOptions = optionArray.map(option => {
            const text = list(option)
            height += text.height
            width = text.width > width ? text.width : width
            return text
        })

        const playOptionAudio = (optionNum: 1 | 2 | 3 | 4) => {
            if (isTitleMenu) {
                Audio.add(game, PersonalityAssets.findFillInBlankTitleAudio(optionNum))
            } else {
                Audio.add(game, PersonalityAssets.findFillInBlankAudio(blankNum, optionNum as 1 | 2 | 3, personalityType))
            }
        }

        // DropDown background
        new Rectangle(game, x, y, width + paddingX * 2, height, {
            fillColor: 0xFFFFFF,
            lineWidth: 1,
            group: this.dropGroup
        })

        this.dropGroup.visible = false

        const answerBox = new Rectangle(game, x, y - scaledHeightFromPx - paddingY,
            width + paddingX * 2, scaledHeightFromPx + paddingY, {lineWidth: 1, group}
        )

        const blank = PhaserText.create(game, placeholder, {
            x: x + paddingX,
            y: y - scaledHeightFromPx - paddingY,
            fontPx,
            group
        })

        const setBlank = (text: string) => {
            if (isTitleMenu) {
                PersonalityStore.instance.articleTitle = text
            } else {
                PersonalityStore.instance.blank = {text, index: blankNum - 1}
            }
            blank.setText(text)
            this.dropGroup.visible = false
            if (PersonalityStore.instance.articleTitle !== "" &&
                PersonalityStore.instance.blanks.indexOf("") === -1) {
                PersonalityStore.instance.storyFinishedButton.enable()
            } else {
                PersonalityStore.instance.storyFinishedButton.disable()
            }
        }

        Buttons.makeSpriteButton(closeDropDownOverlay.invisibleSprite, () => this.dropGroup.visible = false)

        selectOptions.forEach((option, i) => {
            option.bringToTop()
            const hitArea = new Rectangle(game, option.x, option.y, width, option.height, {
                lineWidth: 0,
                group: this.dropGroup
            })
            Buttons.makeSpriteButton(hitArea.invisibleSprite, () => {
                playOptionAudio(i + 1 as 1 | 2 | 3 | 4)
                setBlank(option.text)
            })
        })

        Buttons.makeSpriteButton(answerBox.invisibleSprite, () => {
            game.world.bringToTop(this.dropGroup)
            this.dropGroup.visible = !this.dropGroup.visible
        })
    }
}